import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { OptimizedRouteResponse } from './models/optimized-route';
import { environment } from 'src/environments/environment';
import { RouteResponse } from './models/route';
import { VehicleType } from 'src/app/core/models/vehicle';

@Injectable({ providedIn: 'root' })
export class MapRepo {

    constructor(
        private http: HttpClient
    ) {
    }

    getOptimizedRoute(coordinates: number[][], vehicleType: VehicleType = VehicleType.Car): Observable<OptimizedRouteResponse> {
        const mapBoxVehicleType = this.getMapBoxVehicleType(vehicleType);
        return this.http.get<OptimizedRouteResponse>(
            `https://api.mapbox.com/optimized-trips/v1/mapbox/${mapBoxVehicleType}/${coordinates.join(';')}?overview=full&steps=true&geometries=geojson&source=first&access_token=${environment.mapboxKey}`)
    }

    getRoute(coordinates: number[][], vehicleType: VehicleType = VehicleType.Car): Observable<RouteResponse> {
        const mapBoxVehicleType = this.getMapBoxVehicleType(vehicleType);
        return this.http.get<RouteResponse>(
            `https://api.mapbox.com/directions/v5/mapbox/${mapBoxVehicleType}/${coordinates.join(';')}?overview=full&steps=false&geometries=geojson&continue_straight=false&access_token=${environment.mapboxKey}`)
    }

    private getMapBoxVehicleType(vehicleType: VehicleType): string {
        let mapBoxVehicleType: string;
        switch (vehicleType) {
            case VehicleType.Bicycle:
            case VehicleType.MotorCycle:
                mapBoxVehicleType = "cycling";
                break;
            case VehicleType.Car:
                mapBoxVehicleType = "driving-traffic";
        }
        return mapBoxVehicleType;
    }
}
